// extracted by mini-css-extract-plugin
export default {"toast":"ToastMessage_toast__9lctD","fadeout":"ToastMessage_fadeout__0ilqY"};